import { render } from "./DashboardMixins.vue?vue&type=template&id=792b7cbe"
import script from "./DashboardMixins.vue?vue&type=script&lang=js"
export * from "./DashboardMixins.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__